import { createGlobalStyle } from "styled-components";

export const GlobalDatePickerStyled = createGlobalStyle`
    .react-datepicker {
        background-color: var(--color-purple);
        border-color: var(--color-purple);
        font-family: "OpenSans", sans-serif;
    }

    .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
        border-top-color: var(--color-purple);
    }

    .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
        border-bottom-color: var(--color-purple);
    }

    .react-datepicker__header {
        background-color: var(--color-purple);
    }

    .react-datepicker__day {
        color: var(--color-white);
        font-weight: 400;
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
        background-color: var(--color-yellow);
        font-weight: 600;
        color: var(--color-base);
    }

    .react-datepicker__current-month {
        color: var(--color-white);
    }

    .react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
        background-color: var(--color-yellow);
        color: var(--color-base);
    }
    
    .react-datepicker__day-name {
        color: var(--color-white);
    }
    
    .react-datepicker__day--outside-month {
        color: var(--color-label-secondary);
    }
`;